/** @jsx jsx */
import warningIcon from 'images/warning.svg'
import {Fragment} from 'react'
import {jsx} from 'theme-ui'
import NextButton from './NextButton'

interface IDonationFooter {
  notes: string[]
}

const DonationFooter: React.FC<IDonationFooter> = ({notes}) => {
  return (
    <Fragment>
      <NextButton type="submit"></NextButton>
      {notes.map((note, index) => (
        <div
          key={index}
          sx={{
            mt: 20,
            display: 'flex',
            alignItems: 'flex-start',
          }}
        >
          <img src={warningIcon} alt="Note:" />
          <p
            sx={{
              ml: 5,
              my: 0,
              fontSize: 12,
              maxWidth: 272,
              lineHeight: '14px',
              color: '#717A7B',
            }}
          >
            {note}
          </p>
        </div>
      ))}
    </Fragment>
  )
}

export default DonationFooter
